import React, { useRef } from "react";
import "../../styles/header.css";
import logo from "../../assets/img/MarekLogo.png";
import { useEffect } from "react";

const nav__links = [
  {
    path: "#home",
    display: "About",
  },
  {
    path: "#schedule",
    display: "Reviews",
  },
  {
    path: "#classes",
    display: "Blog",
  },
];

const Header = () => {
  const headerRef = useRef(null);

  const headerFunc = () => {
    if (
      document.body.scrollTop > 80 ||
      document.documentElement.scrollTop > 80
    ) {
      headerRef.current.classList.add("sticky__header");
    } else {
      headerRef.current.classList.remove("sticky__header");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", headerFunc);

    return () => window.removeEventListener("scroll", headerFunc);
  }, []);

  const handleClick = e => {
    e.preventDefault();

    const targetAttr = e.target.getAttribute("href");
    const location = document.querySelector(targetAttr).offsetTop;

    window.scrollTo({
      left: 0,
      top: location - 80,
    });
  };

  return (
    <header className="header" ref={headerRef}>
      <div className="container">
        <div className="nav__wrapper">
          {/* ======= LOGO ========= */}
          <div onClick={() => window.scrollTo(0, 0)} className="logo">
            <div className="logo__img">
              <img src={logo} alt="" />
            </div>
          </div>

          {/* ========== navigation menu ========== */}
          <div className="navigation">
            <ul className="menu">
              {nav__links.map(item => (
                <li className="nav__item">
                  <a onClick={handleClick} href={item.path}>
                    {item.display}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
